export default "__VITE_ASSET__Bd9Ky9WE__";